import * as React from "react";
import Dialog from "@mui/material/Dialog";

export default function DialogCustom({ open, message, action, statusPayment }) {
  return (
    <Dialog
      open={open}
      PaperProps={{
        style: {
          borderRadius: '10px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
          minWidth: '340px',
          maxWidth: '420px',
          overflow: 'hidden',
          margin: '16px',
        },
      }}
    >
      {/* Header */}
      <div style={{ backgroundColor: '#111827', padding: '16px 20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
        <div style={{ width: '30px', height: '30px', borderRadius: '50%', backgroundColor: '#dc2626', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <i className="fa-solid fa-triangle-exclamation" style={{ fontSize: '13px', color: '#fff' }}></i>
        </div>
        <span style={{ fontSize: '0.88rem', fontWeight: 700, color: '#f9fafb' }}>{message.title}</span>
      </div>

      {/* Body */}
      <div style={{ padding: '20px 20px 8px', backgroundColor: '#fff' }}>
        <p style={{ fontSize: '0.85rem', color: '#374151', lineHeight: 1.5, margin: 0 }}>{message.message}</p>
      </div>

      {/* Actions */}
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', padding: '12px 20px 18px', backgroundColor: '#fff' }}>
        <button
          onClick={() => action(false, statusPayment)}
          style={{
            padding: '8px 18px', borderRadius: '6px', border: '1px solid #d1d5db',
            backgroundColor: '#f8fafc', color: '#374151', fontSize: '0.78rem',
            fontWeight: 600, cursor: 'pointer', transition: 'all 0.12s',
          }}
          onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#e2e8f0'; }}
          onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#f8fafc'; }}
        >
          Cancelar
        </button>
        <button
          onClick={() => action(true, statusPayment)}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: '6px',
            padding: '8px 18px', borderRadius: '6px', border: 'none',
            backgroundColor: '#dc2626', color: '#fff', fontSize: '0.78rem',
            fontWeight: 700, cursor: 'pointer', transition: 'all 0.12s',
          }}
          onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#b91c1c'; }}
          onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#dc2626'; }}
        >
          <i className="fa-solid fa-check" style={{ fontSize: '11px' }}></i>
          Aceptar
        </button>
      </div>
    </Dialog>
  );
}
